import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Experience from "./components/Experience";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const App = () => (
  <>
    <Header />
    <main>
      <Hero />
      <div className="wrap">
        <About />
        <Experience />
        <Skills />
        <Projects />
        <Contact />
      </div>
    </main>
    <Footer />
  </>
);

export default App;
